module.exports = __webpack_public_path__ + "img/35.bb228b45.png";